import { DatePicker, Skeleton, Space, Form, Row, Col } from "antd";
import moment from "moment";
import React, { useState, useEffect } from "react";
import "../../css/custom.css";
import BookingDetails from "./BookingDetails";
import Customer from "./customer";
import Footer from "./footer";
import styles from "./Header.module.css";
import { useDispatch, useSelector } from "react-redux";
import Confirmed from "./Confirmed";
import { readGuestParams } from "./guestParams";
import HotelNotFound from "../NotFound/HotelNotFound";
import { bookingStageProps, LOADING_INDICATOR } from "./hotelAdsMarkup";
import {
  clearSavedOrderId,
  getSavedOrderId,
  PaymentConfirming,
  pollBookingStatus,
} from "./bookingPayment";
import {
  getHotelDetails,
  menuItemsListData,
  getAllRateDateWise,
} from "../../redux/HomePage/actionCreater";

import { useParams, useLocation, useNavigate } from "react-router-dom";
function Header({ state }) {
  const dispatch = useDispatch();
  const [load, setLoad] = useState(true);
  let navigate = useNavigate();
  const [hotelData, setHotelData] = useState();
  const [currentRegisterData, setCurrentRegisterData] = useState();
  const params = useParams();
  const [roomType, setRoomtype] = useState([]);
  const [rsSymbol, setRsSymbol] = useState("₹");
  const [shopDetails, setShopDetails] = useState();
  const [rateDateWiseObj, setRateDatewiseRateObj] = useState({});
  const [reservationData, setReservationData] = useState();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const startDate = queryParams.get("startDate");
  const endDate = queryParams.get("endDate");
  const hotelID = queryParams.get("hotelID");
  // URL may use either casing (checkInMonth / checkinMonth), accept both
  const getParam = (...names) => {
    for (const name of names) {
      const value = queryParams.get(name);
      if (value) return value;
    }
    return null;
  };
  const DATE_FORMAT = "ddd DD MMM YYYY";
  const checkInDay = getParam("checkInDay", "checkinDay");
  const checkinMonth = getParam("checkInMonth", "checkinMonth");
  const checkinYear = getParam("checkInYear", "checkinYear");
  const nights = getParam("nights");
  const bookingHotelId = hotelID || params.table_id;
  const parsedCheckIn =
    checkInDay && checkinMonth && checkinYear
      ? moment(`${checkinYear}-${checkinMonth}-${checkInDay}`, "YYYY-M-D")
      : null;
  const today = moment().startOf("day");
  // a past check-in in the URL falls back to today / 1 night
  const isPastCheckIn =
    parsedCheckIn && parsedCheckIn.isValid() && parsedCheckIn.isBefore(today);
  const effectiveCheckIn =
    parsedCheckIn && parsedCheckIn.isValid()
      ? isPastCheckIn
        ? today.clone()
        : parsedCheckIn
      : null;
  const effectiveNights = isPastCheckIn ? 1 : Math.max(Number(nights) || 1, 1);
  const derivedStartDate = effectiveCheckIn
    ? effectiveCheckIn.format(DATE_FORMAT)
    : null;
  const derivedEndDate = effectiveCheckIn
    ? effectiveCheckIn.clone().add(effectiveNights, "days").format(DATE_FORMAT)
    : null;
  const [showBill1, setShowBill1] = useState(false);
  const [color, setColor] = useState("#2d2a21");
  // true when hotel details could not be fetched at all (network/server error)
  const [hotelLoadError, setHotelLoadError] = useState(false);
  const tableData = async () => {
    if (bookingHotelId && bookingHotelId != "home") {
      let response1;
      try {
        response1 = await dispatch(getHotelDetails(bookingHotelId));
      } catch (err) {
        setHotelLoadError(true);
        setLoad(false);
        return;
      }
      if (response1 && response1.data) {
        setColor(response1.data?.bg_color);
        setHotelData(response1.data);
        setLoad(false);
      }
    } else {
      setLoad(false);
    }
  };
  const [roomFetchLeader, setRoomFetchLoader] = useState(true);
  const [stayForm] = Form.useForm();
  const tableData1 = async (stayStart, stayEnd) => {
    if (bookingHotelId && bookingHotelId != "home") {
      setRoomFetchLoader(true);
      let response;
      try {
        response = await dispatch(
          menuItemsListData(bookingHotelId, {
            startDate: stayStart,
            endDate: stayEnd,
          }),
        );
      } catch (err) {
        setHotelLoadError(true);
        setRoomFetchLoader(false);
        return;
      }
      if (response && response.data) {
        let { shopDetails, roomTypeList, registerDetails } = response.data;
        console.log("roomTypeListroomTypeList", roomTypeList);

        setRoomtype(roomTypeList);
        setRsSymbol(
          shopDetails?.rs_symbol
            ? /\(([^)]+)\)/.exec(shopDetails.rs_symbol)?.length > 0
              ? /\(([^)]+)\)/.exec(shopDetails.rs_symbol)[1]
              : shopDetails.rs_symbol
            : "₹",
        );
        setShopDetails(shopDetails);
        setCurrentRegisterData(registerDetails);

        setRoomFetchLoader(false);
      }
    } else {
      setRoomFetchLoader(false);
    }
  };
  useEffect(() => {
    if (!reservationData) {
      tableData();
    }
  }, [reservationData]);
  // { orderId, timedOut } while resuming an online payment this tab started
  // but never saw confirmed (tab closed / network lost after paying)
  const [resumeOrder, setResumeOrder] = useState(null);
  useEffect(() => {
    const orderId = hotelData && getSavedOrderId();
    if (!orderId) return;
    let cancelled = false;
    setResumeOrder({ orderId });
    pollBookingStatus({
      dispatch,
      orderId,
      immediate: true,
      stopWhenUnpaid: true,
      isCancelled: () => cancelled,
    }).then((result) => {
      if (result.cancelled) return;
      if (result.reservation) {
        clearSavedOrderId();
        setReservationData(result.reservation);
        setResumeOrder(null);
      } else if (result.notPaid || result.notFound) {
        // guest closed Checkout without paying: normal page
        clearSavedOrderId();
        setResumeOrder(null);
      } else {
        // still not booked: keep the order id for the next reload
        setResumeOrder({ orderId, timedOut: true });
      }
    });
    return () => {
      cancelled = true;
    };
  }, [hotelData]);
  const resumeModal = resumeOrder && (
    <PaymentConfirming
      orderId={resumeOrder.orderId}
      timedOut={resumeOrder.timedOut}
    />
  );
  const disabledDate = (current) => {
    return current && current < moment().startOf("day");
  };
  // never let a stale/past date land in state, clamp it to today
  const notBeforeToday = (value) => {
    if (!value) return null;
    const parsed = moment(value, DATE_FORMAT);
    if (!parsed.isValid() || parsed.isBefore(today)) return null;
    return parsed.format(DATE_FORMAT);
  };
  const buildInitialStay = () => {
    const legacyStart = notBeforeToday(startDate);
    if (legacyStart) {
      const legacyEnd = notBeforeToday(endDate);
      const isValidRange =
        legacyEnd &&
        moment(legacyEnd, DATE_FORMAT).isAfter(
          moment(legacyStart, DATE_FORMAT),
        );
      return {
        start: legacyStart,
        end: isValidRange
          ? legacyEnd
          : moment(legacyStart, DATE_FORMAT).add(1, "day").format(DATE_FORMAT),
      };
    }
    if (derivedStartDate && derivedEndDate) {
      return { start: derivedStartDate, end: derivedEndDate };
    }
    return {
      start: today.clone().format(DATE_FORMAT),
      end: today.clone().add(1, "day").format(DATE_FORMAT),
    };
  };
  const { start: initialStartDate, end: initialEndDate } = buildInitialStay();
  const [reservationStartDate, setReservationStartDate] =
    useState(initialStartDate);
  const [reservationEndDate, setReservationEndDate] = useState(initialEndDate);
  // guests per room come only from the URL (?adults=N&children=N);
  // null when neither is set -> rooms use their default occupancy
  const [guests, setGuests] = useState(() => readGuestParams(location.search));
  function disabledEndDate(current) {
    return current && current <= moment(reservationStartDate, DATE_FORMAT);
  }
  // pmsInfo expects the stay as plain YYYY-MM-DD query params
  const API_DATE_FORMAT = "YYYY-MM-DD";
  const toApiDate = (value) => {
    const parsed = moment(value, DATE_FORMAT);
    return parsed.isValid() ? parsed.format(API_DATE_FORMAT) : null;
  };
  const apiStartDate = toApiDate(reservationStartDate);
  const apiEndDate = toApiDate(reservationEndDate);
  // room types / rates depend on the picked stay, so refetch when it changes
  useEffect(() => {
    if (!reservationData && apiStartDate && apiEndDate) {
      tableData1(apiStartDate, apiEndDate);
    }
  }, [reservationData, apiStartDate, apiEndDate]);

  const handleDateChange = (dates) => {
    setReservationStartDate(moment(dates[0]).format(DATE_FORMAT));
    setReservationEndDate(moment(dates[1]).format(DATE_FORMAT));
  };
  // keep the pickers showing whatever dates the URL / state currently hold
  useEffect(() => {
    stayForm.setFieldsValue({
      stay_start_date: moment(reservationStartDate, DATE_FORMAT),
      stay_end_date: moment(reservationEndDate, DATE_FORMAT),
    });
  }, [reservationStartDate, reservationEndDate]);
  // push the selected stay back into the URL as checkIn* + nights + guests
  useEffect(() => {
    const start = moment(reservationStartDate, DATE_FORMAT);
    const end = moment(reservationEndDate, DATE_FORMAT);
    if (!start.isValid() || !end.isValid()) return;
    const nightCount = Math.max(end.diff(start, "days"), 1);
    const next = new URLSearchParams(location.search);
    // drop every stay key first so they are re-appended in a fixed order,
    // with nights + guests always last
    [
      "startDate",
      "endDate",
      "checkinDay",
      "checkinMonth",
      "checkinYear",
      "checkInDay",
      "checkInMonth",
      "checkInYear",
      "nights",
      "adult",
      "adults",
      "child",
      "children",
    ].forEach((key) => next.delete(key));
    if (hotelID) next.set("hotelID", hotelID);
    next.append("checkInDay", start.format("DD"));
    next.append("checkInMonth", start.format("MM"));
    next.append("checkInYear", start.format("YYYY"));
    next.append("nights", String(nightCount));
    if (guests) {
      next.append("adults", String(guests.adults));
      next.append("children", String(guests.children));
    }
    const search = `?${next.toString()}`;
    if (search !== location.search) {
      navigate({ pathname: location.pathname, search }, { replace: true });
    }
  }, [reservationStartDate, reservationEndDate, guests]);
  const [rateLoader, setRateLoader] = useState(false);
  const fetchDateWiseRate = async () => {
    if (!bookingHotelId) {
      setRateLoader(false);
      return;
    }
    setRateLoader(true);
    let startDate = moment(reservationStartDate, DATE_FORMAT).format(
      "MM/DD/YYYY",
    );
    let endDate = moment(reservationEndDate, DATE_FORMAT)
      .subtract(1, "days")
      .format("MM/DD/YYYY");
    const getRateList = await dispatch(
      getAllRateDateWise(bookingHotelId, {
        startDate: startDate,
        endDate: endDate,
      }),
    );
    if (getRateList && getRateList.data) {
      let obj = {};
      getRateList.data.map((k) => {
        obj[`${moment(k.date).format("MM/DD/YYYY")}-${k.rate_id}`] = k;
      });
      setRateDatewiseRateObj(obj);
      setRateLoader(false);
      return obj;
    }
  };
  useEffect(() => {
    if (!reservationData) {
      fetchDateWiseRate();
    }
  }, [reservationStartDate, reservationData, reservationEndDate]);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [reservationData]);
  const navigateHotelPage = () => {
    navigate(`/hotel/${bookingHotelId}`);
  };
  const [windowWidth, setWindowWidth] = useState(
    window.innerWidth > 0 ? window.innerWidth : window.outerWidth,
  );
  useEffect(() => {
    setWindowWidth(
      window.innerWidth > 0 ? window.innerWidth : window.outerWidth,
    );
  }, [window.innerWidth > 0 ? window.innerWidth : window.outerWidth]);
  if (hotelLoadError) {
    return (
      <HotelNotFound
        hotelId={bookingHotelId}
        error
        onRetry={() => window.location.reload()}
      />
    );
  }
  if (load || rateLoader || roomFetchLeader) {
    return (
      <div className={styles.SkeletonContainer} {...LOADING_INDICATOR}>
        {resumeModal}
        <Skeleton title width={150} active={true} />
        <br />
        <br />
        <div className={styles.cardSkeleton}>
          <Skeleton paragraph={{ rows: 3 }} active={true} />
          <Skeleton.Image active={true} />
        </div>
        <br />
        <div className={styles.cardSkeleton}>
          <Skeleton paragraph={{ rows: 3 }} active={true} />
          <Skeleton.Image active={true} />
        </div>
        <br />
        <div className={styles.cardSkeleton}>
          <Skeleton paragraph={{ rows: 3 }} active={true} />
          <Skeleton.Image active={true} />
        </div>
        <Space>
          <Skeleton.Button active={true} size="large" />
          <Skeleton.Input active={true} />
        </Space>
      </div>
    );
  }
  // an unknown hotelID still gets 200s, just with empty data everywhere:
  // booking_setup -> {}, pmsInfo -> {} register/shop details
  const isEmptyObject = (value) =>
    !!value && typeof value === "object" && !Object.keys(value).length;
  const hotelNotFound =
    !bookingHotelId ||
    (isEmptyObject(hotelData) &&
      isEmptyObject(shopDetails) &&
      isEmptyObject(currentRegisterData));
  if (!reservationData && hotelNotFound) {
    return <HotelNotFound hotelId={bookingHotelId} />;
  }
  console.log("hotelData12131132", hotelData);
  // Hotel Ads crawler stages; the post-booking confirmation is not one
  const isFinalStage = !reservationData && showBill1;
  return (
    <div {...(reservationData ? {} : bookingStageProps(isFinalStage))}>
      {resumeModal}
      <header className={styles.mainHeader} style={{ "--text-color": color }}>
        <div className="container">
          <div>
            <h1
              style={{ cursor: "pointer" }}
              onClick={navigateHotelPage}
              itemProp={isFinalStage ? "name" : undefined}
            >
              {hotelData?.hotel_name}
            </h1>
            {/* must equal the hotel id in the Hotel Ads feed */}
            {isFinalStage && (
              <meta itemProp="identifier" content={bookingHotelId} />
            )}
            <div className={`row ${styles.headerInfo}`}>
              <div className="col-12 col-md-6 col-lg-2  d-flex gap-3">
                <i class="fa-solid fa-hotel"></i>
                <p>Hotel Details</p>
              </div>
              <div className=" col-12 col-md-6 d-flex gap-3">
                <i class="fa-solid fa-location-dot"></i>
                <p>{hotelData?.hotel_address}</p>
              </div>
              <div className="col-12 col-md-6 col-lg-2 d-flex gap-3">
                <i class="fa-solid fa-phone-volume"></i>
                <a href="#">{hotelData?.hotel_mobile}</a>
              </div>
              <div className="col-12 col-md-6 col-lg-2 d-flex gap-3">
                <i class="fa-regular fa-star"></i>
                <p>4.8 (1285 reviews)</p>
              </div>
            </div>
          </div>
        </div>
      </header>
      {!reservationData && showBill1 == false && (
        <section className={styles.checkSection}>
          <div className="container">
            <div className="d-flex align-items-center gap-3">
              <h2>Check In & Check Out</h2>
              <Space direction="vertical" className={styles.spaceHeaderPicker}>
                <Form form={stayForm} name="stayDetails">
                  <Row>
                    <Col
                      md={12}
                      sm={12}
                      lg={12}
                      xxl={12}
                      xs={24}
                      className="gutter-row"
                    >
                      <Form.Item
                        name="stay_start_date"
                        className={styles.startEndDate}
                      >
                        <DatePicker
                          allowClear={false}
                          style={{ width: "100%" }}
                          defaultValue={moment(
                            reservationStartDate,
                            DATE_FORMAT,
                          )}
                          size="large"
                          disabledDate={disabledDate}
                          onChange={(date, string) => {
                            let nights = moment(
                              reservationEndDate,
                              DATE_FORMAT,
                            ).diff(moment(string, DATE_FORMAT), "days");
                            setReservationStartDate(string);
                            let outDate = reservationEndDate;
                            if (nights <= 0) {
                              outDate = moment(string, DATE_FORMAT)
                                .add(1, "days")
                                .format(DATE_FORMAT);
                              stayForm.setFieldsValue({
                                stay_end_date: moment(outDate, DATE_FORMAT),
                              });
                              setReservationEndDate(outDate);
                            }
                          }}
                          format={DATE_FORMAT}
                        />
                      </Form.Item>
                    </Col>
                    <Col md={12} sm={12} lg={12} xxl={12} xs={24}>
                      <Form.Item
                        name="stay_end_date"
                        className={styles.startEndDate}
                      >
                        <DatePicker
                          allowClear={false}
                          style={{ width: "100%" }}
                          defaultValue={moment(reservationEndDate, DATE_FORMAT)}
                          size="large"
                          disabledDate={disabledEndDate}
                          onChange={(date, string) => {
                            setReservationEndDate(string);
                          }}
                          format={DATE_FORMAT}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </Space>
            </div>
          </div>
        </section>
      )}

      {reservationData ? (
        <Confirmed
          setReservationData={setReservationData}
          reservationData={reservationData}
          currentRegisterData={currentRegisterData}
          reservationStartDate={reservationStartDate}
          reservationEndDate={reservationEndDate}
          setReservationStartDate={setReservationStartDate}
          setReservationEndDate={setReservationEndDate}
          shopDetails={shopDetails}
          color={color}
        />
      ) : (
        <BookingDetails
          currentRegisterData={currentRegisterData}
          roomType={roomType}
          rsSymbol={rsSymbol}
          shopDetails={shopDetails}
          reservationStartDate={reservationStartDate}
          reservationEndDate={reservationEndDate}
          rateDateWiseObj={rateDateWiseObj}
          cancelPolicy={
            hotelData?.cancel_policy ? hotelData?.cancel_policy : ""
          }
          termCondtion={
            hotelData?.term_condtion ? hotelData?.term_condtion : ""
          }
          privacyPolicy={
            hotelData?.privacy_policy ? hotelData?.privacy_policy : ""
          }
          setReservationData={setReservationData}
          reservationData={reservationData}
          searchAdults={guests?.adults}
          searchChildren={guests?.children}
          onClearGuests={() => setGuests(null)}
          currency={hotelData?.currency}
          custom_payment={hotelData?.custom_payment}
          setShowBill1={setShowBill1}
          showBill1={showBill1}
          paymentType={hotelData?.payment_type}
          price_adjustment={hotelData?.price_adjustment}
          percentage_adjustment={hotelData?.percentage_adjustment}
          color={color}
        />
      )}
      {windowWidth > 800 && (
        <Footer hotelData={hotelData} color={color} hotelId={bookingHotelId} />
      )}
    </div>
  );
}

export default Header;
